<script setup lang="ts">
/***
 * template to show related Ticket
 */
import LinkedTicketTag from '@/components/LinkedTicketTag.vue';

import type { DataTableCellProps } from './templateTypes';

const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <div v-if="cell.value">
    <ExpandableCell :data-key="dataKey" :field="column.field">
      <!-- Collapsed content -->
      <template #collapsed>
        <div class="flex items-center gap-2">
          <LinkedTicketTag :ticketId="cell.meta('rawvalue')" :crop="0" />
        </div>
      </template>
      <!-- Expanded content -->
      <template #expanded>
        <LinkedTicketTag :ticketId="cell.meta('rawvalue')" :crop="32" />
      </template>
    </ExpandableCell>
  </div>
  <div v-else>-</div>
</template>
